import { useCallback, useEffect, useRef } from 'react';

export const useScrollLock = () => {
  const scrollPosition = useRef(0);

  const lockScroll = useCallback(() => {
    // Save current scroll position
    scrollPosition.current = window.pageYOffset;
    
    // Apply styles to lock scroll
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition.current}px`;
    document.body.style.width = '100%';
  }, []);

  const unlockScroll = useCallback(() => {
    // Remove styles
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    
    // Restore scroll position
    window.scrollTo(0, scrollPosition.current);
  }, []);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      unlockScroll();
    };
  }, [unlockScroll]);

  return { lockScroll, unlockScroll };
};
